<template>
  <div v-if="inPerilOfLosingBackerPlan">
    <div class="message with-icon danger">
      <font-awesome-icon
        :icon="$v6.solid.faBomb"
        class="decorative"
      />
      <span>If your Pro Backer plan expires, you'll lose your special Backer subscription price!</span>
    </div>
  </div>
</template>

<script>
  import get from 'lodash/get'

  export default {
    name: 'AdditionalWarnings',

    props: {
      subscription: {
        type: Object
      },

      determinations: {
        type: Object,
        required: true
      },

      colorSet: {
        type: Object
      }
    },

    computed: {
      inPerilOfLosingBackerPlan() {
        return (
          get(this, ['subscription', 'plan', 'sku']) === 'FA-BACKER' &&
          !this.determinations.ended &&
          (this.determinations.indication === 'warning' || this.determinations.indication === 'danger')
        )
      }
    }
  }
</script>
